import * as React from "react";
import { Row, Col, Button, List, Card } from "antd";
import moment from "moment";
import { TrackedBolDetailRow, GenColLayout, StatusHistoryColLayout } from "./TrackedBolDetailView.Style";
import { TrackedBolDetailViewHandler } from "./TrackedBolDetailViewHandler";
import { GetTrackedBolDetailsByIdCommandResponse, GetTrackedBolDetailsByIdCommandRequest, TrackedBol } from "Core/Api/Kopp/Api";
import NotificationUtility from "Core/NotificationUtility";
import * as QueryString from "query-string";
import { RouteComponentProps, withRouter, Redirect } from "react-router-dom";
import { stat } from "fs";
import Utility from "Core/Utility";
import { BolFilesEditor } from "components/Forms/BolFilesEditor";
import ShowIfTrue from "components/Forms/ShowIfTrue";
import NumberFormat from "react-number-format";

export interface Props extends RouteComponentProps {
    children?: React.ReactNode
}

export interface State {
    trackedBolDetails: GetTrackedBolDetailsByIdCommandResponse;
}

class BaseTrackedBolDetailView extends React.Component<Props, State> {
    handler: TrackedBolDetailViewHandler;

    constructor(props: Props) {
        super(props)
        this.handler = new TrackedBolDetailViewHandler(props);

        this.state = {
            trackedBolDetails: new GetTrackedBolDetailsByIdCommandResponse(),
        }
    }

    componentDidMount() {
        if (QueryString.parse(this.props.location.search) !== undefined) {
            const { id } = QueryString.parse(this.props.location.search);
            if (id != null || id != undefined) {
                let request = new GetTrackedBolDetailsByIdCommandRequest();
                request.id = id;
                this.GetTrackedBolById(request);
            }
            else {
                NotificationUtility.info("No Bill of Lading with that number found.", "", 30, true);
                //TODO: CHANGE TO CLICK N GO PAGE WHEN IT IS OFFICIALLY CREATED
                this.props.history.push("/home");
            }
        }
    }

    GetTrackedBolById(value: GetTrackedBolDetailsByIdCommandRequest) {
        this.handler.GetTrackedBolById(value)
            .then(response => {
                if (response.trackedBol) {
                    this.setState({ trackedBolDetails: response });
                    // console.log(this.state.trackedBolDetails, "tracked bol")
                }
            })
            .catch(() => {
                NotificationUtility.error("There was an issue retreiving this Click N Go Details.", "", 0, true);
                this.props.history.push("/click-n-go");
            })
    }


    render() {
        const { trackedBol } = this.state.trackedBolDetails;
        return (
            <TrackedBolDetailRow>
                <Row style={{ marginBottom: 10 }}>
                    <Col span={2}>
                        <Button icon="arrow-left" size="small" onClick={() => this.props.history.push("/click-n-go")} type="primary">
                            Back
                    </Button>
                    </Col>

                </Row>
                <Col style={{ textAlign: 'left' }}>
                    <section style={{ marginBottom: 15, border: "1.5px solid transparent", borderBottomColor: "lightgrey", paddingBottom: 10 }}>
                        <Row>
                            <Col {...GenColLayout}>
                                <Row>
                                    <Col>
                                        <b>Click N Collect #:</b> {trackedBol?.cngReferenceNumber}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <b>Vessel:</b> {trackedBol?.vessel}
                                    </Col>
                                </Row>
                            </Col>
                            <Col {...GenColLayout}>
                                <Row>
                                    <Col>
                                        <b>BL #:</b> {trackedBol?.bolNumber}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <b>Voyage:</b> {trackedBol?.voyage ? Utility.ToDateString(trackedBol?.voyage) : null}
                                    </Col>
                                </Row>
                            </Col>
                            <Col  {...GenColLayout}>
                                <Row>
                                    <Col>
                                        <b>Status:</b> {trackedBol?.currentStatusForCustomer}
                                    </Col>
                                </Row>

                                <Row>
                                    <Col>
                                        <b>Arrival Date:</b> {trackedBol?.arrivalDate ? Utility.ToDateString(trackedBol?.arrivalDate) : null}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </section>
                    <section style={{ marginBottom: 10, border: "1.5px solid transparent", borderBottomColor: "lightgrey", paddingBottom: 10 }}>
                        <Row>
                            <Col >
                                <Row>
                                    <Col>
                                        <b>Description:</b> {Object.values(trackedBol?.tariffCodeDescription ?? {}).reduce((prev, current) => `${prev}, ${current}`, "").substring(1)}
                                    </Col>
                                </Row>
                                <Row>
                                    <ShowIfTrue condition={trackedBol?.value}>
                                        <Col>
                                            <b>Value:</b> <NumberFormat value={trackedBol?.value} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                        </Col>
                                    </ShowIfTrue>
                                </Row>

                            </Col>
                        </Row>

                    </section>

                    <section style={{ marginBottom: 15, border: "1.5px solid transparent", borderBottomColor: "lightgrey", paddingBottom: 10 }}>
                        <Row>
                            <Col >
                                <Row>
                                    <Col> <b>Files:</b></Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <BolFilesEditor value={trackedBol?.bolFiles} readonly />
                                    </Col>
                                </Row>

                            </Col>
                        </Row>
                    </section>
                    <section style={{ marginBottom: 15 }}>
                        <Row>
                            <Col span={8} style={{ fontWeight: "bold", fontSize: 16 }}>Status History</Col>
                        </Row>
                        <Row>
                            <Col>
                                <List
                                    dataSource={trackedBol?.trackedBolHistories}
                                    renderItem={item =>
                                        <div >
                                            <Row style={{ textAlign: "left", marginTop: 5, backgroundColor: "#f8f8f8", padding: 10 }}>
                                                <Col {...StatusHistoryColLayout}>
                                                    Action: {item.currentStatusForCustomer}
                                                </Col>
                                                <Col {...StatusHistoryColLayout}>
                                                    DateTime: {item.creationDate ? Utility.ToDateTimeString(item.creationDate) : null}
                                                </Col>
                                                {item.comment && <Col {...StatusHistoryColLayout} >Comment: {item.comment}</Col>}

                                            </Row>
                                        </div>
                                    }
                                />
                            </Col>
                        </Row>
                    </section>
                </Col>
            </TrackedBolDetailRow>
        )
    }
}

const TrackedBolDetailView = withRouter(BaseTrackedBolDetailView);

export default TrackedBolDetailView;
